import React from "react";
import { connect } from "react-redux";
import {
	fetchEstablishments,
	selectSurveyEstablishment,
	searchAnywhereEstablishments,
	startWithEstablishments,
	selectSignedSearch,
	selectRejectedSearch,
	selectApprovedSearch,
	SignedStates,
	RejectedStates,
	ApprovedStates
} from "./EstablishmentsActions";
import {
	Segment,
	Header,
	Feed,
	List,
	Input,
	Divider,
	Grid,
	Form,
	Button,
	Radio
} from "semantic-ui-react";
import { translate } from "react-i18next";

class EstablishmentsComponent extends React.Component {
	onChangeSearchAnywhere = (event, data) => {
		this.props.searchAnywhere(data.value);
	};

	onChangeStartWith = (event, data) => {
		this.props.startWith(data.value);
	};

	selectItemEstablishment = (id) => {
		const { t } = this.props;
		if(this.props.unsavedForm) {
			if(window.confirm(t("confirmSelect"))) {
				this.props.selectItem(id);
				this.props.unsavedFormClear();
			}
		} else {
			this.props.selectItem(id);
		}
	};

	render() {
		const { t } = this.props;
		return (
			<div>
				<Header style={{ marginLeft: "20px" }} as="h3">
					{t("surveyEstablishmentsResult")}
				</Header>
				<Divider horizontal />
				<Grid columns={1} stackable>
					<Grid.Column>
						<Segment
							raised
							padded
							stacked
							loading={this.props.isFetchingResult}
							disabled={this.props.isFetchingResult}
						>
							<List celled selection>
								<List.Header>
									<Form>
										<Form.Group>
											<Form.Field
												control={Input}
												placeholder={t(
													"searchAnywhere"
												)}
												value={
													this.props
														.searchAnywhereParam
												}
												onChange={
													this.onChangeSearchAnywhere
												}
											/>
											<Form.Field
												control={Input}
												placeholder={t("startWith")}
												value={
													this.props.startWithParam
												}
												onChange={
													this.onChangeStartWith
												}
											/>
											<Form.Field
												control={Button}
												onClick={() =>
													this.props.dispatch(
														fetchEstablishments(
															true
														)
													)
												}
											>
												{t("searchAction")}
											</Form.Field>
										</Form.Group>
										<Form.Group>
											<Form.Field>{t('signed')}</Form.Field>
											<Form.Field>
												<Radio
													label={t('all')}
													name="radioGroupSigned"
													checked={this.props.signedSearch === SignedStates.ALL}
													onChange={() => this.props.selectSignedSearchDispatch(SignedStates.ALL)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('yes')}
													name="radioGroupSigned"
													checked={this.props.signedSearch === SignedStates.YES}
													onChange={() => this.props.selectSignedSearchDispatch(SignedStates.YES)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('no')}
													name="radioGroupSigned"
													checked={this.props.signedSearch === SignedStates.NO}
													onChange={() => this.props.selectSignedSearchDispatch(SignedStates.NO)}
												/>
											</Form.Field>
										</Form.Group>

										<Form.Group>
											<Form.Field>{t('rejected')}</Form.Field>
											<Form.Field>
												<Radio
													label={t('all')}
													name="radioGroupRejected"
													checked={this.props.rejectedSearch === RejectedStates.ALL}
													onChange={() => this.props.selectRejectedSearchDispatch(RejectedStates.ALL)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('yes')}
													name="radioGroupRejected"
													checked={this.props.rejectedSearch === RejectedStates.YES}
													onChange={() => this.props.selectRejectedSearchDispatch(RejectedStates.YES)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('no')}
													name="radioGroupRejected"
													checked={this.props.rejectedSearch === RejectedStates.NO}
													onChange={() => this.props.selectRejectedSearchDispatch(RejectedStates.NO)}
												/>
											</Form.Field>
										</Form.Group>



										<Form.Group>
											<Form.Field>{t('approvedSurvey')}</Form.Field>
											<Form.Field>
												<Radio
													label={t('all')}
													name="radioGroupApproved"
													checked={this.props.approvedSearch === ApprovedStates.ALL}
													onChange={() => this.props.selectApprovedSearchDispatch(ApprovedStates.ALL)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('yes')}
													name="radioGroupApproved"
													checked={this.props.approvedSearch === ApprovedStates.YES}
													onChange={() => this.props.selectApprovedSearchDispatch(ApprovedStates.YES)}
												/>
											</Form.Field>
											<Form.Field>
												<Radio
													label={t('no')}
													name="radioGroupApproved"
													checked={this.props.approvedSearch === ApprovedStates.NO}
													onChange={() => this.props.selectApprovedSearchDispatch(ApprovedStates.NO)}
												/>
											</Form.Field>
										</Form.Group>
									</Form>
									<Divider horizontal />
								</List.Header>
								<List.Content
									style={{
										height: "351px",
										overflowY: "auto",
										overflowX: "hidden"
									}}
								>
									{this.props.items.map(item => (
										<List.Item
											key={item.id}
											style={{
												backgroundColor: item.selected
													? "rgb(243, 244, 245)"
													: "#fff"
											}}
											onClick={() =>
												this.selectItemEstablishment(item.id)
											}
										>
											<span
												style={{ marginRight: "2rem" }}
											>
												{item.search_id}
											</span>
											<span>
												{this.props.activeLangCode ===
												"en"
													? item.name_english
													: item.name}
											</span>
										</List.Item>
									))}
								</List.Content>
							</List>
							<Feed size="small">
								<Feed.Event>
									<Feed.Content>
										<Feed.Summary>
											<Feed.Date>
												{this.props.items.length}{" "}
												{" " + t("loadedOf") + " "}{" "}
												{this.props.count}{" "}
											</Feed.Date>
											{this.props.items.length <
												this.props.count && (
												<a
													onClick={
														this.props
															.loadMoreSurveyEstablishments
													}
												>
													{" " + t("loadMore")}
												</a>
											)}
										</Feed.Summary>
									</Feed.Content>
								</Feed.Event>
							</Feed>
						</Segment>
					</Grid.Column>
				</Grid>
				<Divider horizontal />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isFetchingResult: state.establishmentsReducer.isFetching,
		items: state.establishmentsReducer.surveyEstablishments,
		searchParameter: state.establishmentsReducer.searchParameter,
		isFetching: state.establishmentsReducer.isFetching,
		searchAnywhereParam: state.establishmentsReducer.searchAnywhereParam,
		startWithParam: state.establishmentsReducer.startWithParam,
		count: state.establishmentsReducer.count,
		activeLangCode: state.internationalizationReducer.activeLangCode,
		signedSearch: state.establishmentsReducer.signedSearch,
		rejectedSearch: state.establishmentsReducer.rejectedSearch,		
		approvedSearch: state.establishmentsReducer.approvedSearch
	};
};

const mapDispatchToProps = dispatch => {
	return {
		selectItem: resultId => {
			dispatch(selectSurveyEstablishment(resultId));
		},
		searchAnywhere: searchAnywhereParam => {
			dispatch(searchAnywhereEstablishments(searchAnywhereParam));
		},
		startWith: startWithParam => {
			dispatch(startWithEstablishments(startWithParam));
		},
		loadMoreSurveyEstablishments: () => {
			dispatch(fetchEstablishments());
		},
		selectSignedSearchDispatch: signedSearch => {
			dispatch(selectSignedSearch(signedSearch));
		},
		selectRejectedSearchDispatch: rejectedSearch => {
			dispatch(selectRejectedSearch(rejectedSearch));
		},		
		selectApprovedSearchDispatch: approvedSearch => {
			dispatch(selectApprovedSearch(approvedSearch));
		},
		dispatch: dispatch
	};
};

const EstablishmentsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(EstablishmentsComponent);

export default translate()(EstablishmentsContainer);



// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/establishments/EstablishmentsContainer.js